import React, { useEffect, useState } from 'react';
import { View, StyleSheet, ActivityIndicator } from 'react-native';
import * as Font from 'expo-font';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import SplashScreen from './screens/SplashScreen';
import { ThemeProvider } from './screens/ThemeContext';
import { AuthProvider } from './private/AuthContext';

import TabNavigatorUser from './navigations/TabNavigatorUser';
import TabNavigatorCentre from './navigations/TabNavigatorCentre';
import TabNavigatorAdmin from './navigations/TabNavigatorAdmin';

import EditProfileScreenUser from './users/EditProfileScreenUser';
import EditProfileScreenAdmin from './admin/EditProfileScreenAdmin';
import EditProfileScreenCentre from './centres/EditProfileScreenCentre';
import HistoriqueScreenUser2 from './users/HistoriqueScreenUser2';
import FAQItem from './screens/FAQItem';
import AboutScreen from './screens/AboutScreen';
import TermsOfServiceScreen from './screens/TermsOfServiceScreen';
import PrivacyPolicyScreen from './screens/PrivacyPolicyScreen';
import LoginScreen from './private/LoginScreen';
import RegisterScreen from './private/RegisterScreen';
import RenewAnnouncementScreen from './private/RenewAnnouncementScreen';
import centreDetail from './centres/centreDetail';
import CentreScreenCentre2 from './centres/CentreScreenCentre2';
import CreateContentScreen from './centres/CreateContentScreen';
import PublishDocumentScreen from './admin/PublishDocumentScreen';
import ManageDocumentsScreen from './admin/ManageDocumentsScreen';
import DocumentDetailScreen from './admin/DocumentDetailScreen';
import DocumentDetailsScreenUser from './users/DocumentDetailsScreenUser';
import ManageCentersScreen from './admin/ManageCentersScreen';
import CenterDetailScreen from './admin/CenterDetailScreen';
import AnnouncementDetailScreen from './admin/AnnouncementDetailScreen';
import ManageAnnouncementsScreen from './admin/ManageAnnouncementsScreen';
import AdminVerificationAnnonceScreen from './admin/AdminVerificationAnnonceScreen';
import AdminVerificationAnnonceDetailScreen from './admin/AdminVerificationAnnonceDetailScreen';
import AddAdmin from './admin/AddAdmin';
import ManageUsersScreen from './admin/ManageUsersScreen';
import ManagePaymentsScreen from './admin/ManagePaymentsScreen';
import PaymentDetailScreen from './admin/PaymentDetailScreen';
import CentreScreenDetailleUser from './users/CentreScreenDetailleUser';
import HistoriqueDetailScreen from './users/HistoriqueDetailScreen';
import EditContentScreen from './centres/EditContentScreen';
import EditDocumentScreen from './admin/EditDocumentScreen';
import NotificationsScreen from './screens/NotificationsScreen';
import PaymentScreen from './private/PaymentScreen';
import ForgotPasswordScreen from './private/ForgotPasswordScreen';
import AnnouncementPaymentScreen from './private/AnnouncementPaymentScreen';
import PDFViewer from './private/PDFViewer';
import UserDetailScreen from './admin/UserDetailScreen';
import SupportScreen from './screens/SupportScreen';
import ChatMayaScreen from './users/maya/ChatMayaScreen';
import AnalyticsScreen from './admin/AnalyticsScreen';

const Stack = createStackNavigator();

function Navigation() {

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        cardStyle: { backgroundColor: '#fff' },
        detachPreviousScreen: false,
        cardStyleInterpolator: ({ current }) => ({
          cardStyle: {
            opacity: current.progress,
          },
        }),
      }}
      initialRouteName="SplashScreen"
    >
      <Stack.Screen name="SplashScreen" component={SplashScreen} options={{ gestureEnabled: false }} />
      <Stack.Screen name="TabNavigatorUser" component={TabNavigatorUser} options={{ gestureEnabled: false }} />
      <Stack.Screen name="TabNavigatorCentre" component={TabNavigatorCentre} options={{ gestureEnabled: false }} />
      <Stack.Screen name="TabNavigatorAdmin" component={TabNavigatorAdmin} options={{ gestureEnabled: false }} />

      {/* Autres écrans */}
      <Stack.Screen name="EditProfileScreenUser" component={EditProfileScreenUser} />
      <Stack.Screen name="HistoriqueScreenUser2" component={HistoriqueScreenUser2} />
      <Stack.Screen name="FAQItem" component={FAQItem} />
      <Stack.Screen name="AboutScreen" component={AboutScreen} />
      <Stack.Screen name="TermsOfServiceScreen" component={TermsOfServiceScreen} />
      <Stack.Screen name="PrivacyPolicyScreen" component={PrivacyPolicyScreen} />
      <Stack.Screen name="LoginScreen" component={LoginScreen} />
      <Stack.Screen name="RegisterScreen" component={RegisterScreen} />
      <Stack.Screen name="centreDetail" component={centreDetail} />
      <Stack.Screen name="CentreScreenCentre2" component={CentreScreenCentre2} />
      <Stack.Screen name="CreateContentScreen" component={CreateContentScreen} />
      <Stack.Screen name="PublishDocumentScreen" component={PublishDocumentScreen} />
      <Stack.Screen name="ManageDocumentsScreen" component={ManageDocumentsScreen} />
      <Stack.Screen name="DocumentDetailScreen" component={DocumentDetailScreen} />
      <Stack.Screen name="DocumentDetailsScreenUser" component={DocumentDetailsScreenUser} />
      <Stack.Screen name="EditProfileScreenAdmin" component={EditProfileScreenAdmin} />
      <Stack.Screen name="EditProfileScreenCentre" component={EditProfileScreenCentre} />
      <Stack.Screen name="ManageCentersScreen" component={ManageCentersScreen} />
      <Stack.Screen name="CenterDetailScreen" component={CenterDetailScreen} />
      <Stack.Screen name="AnnouncementDetailScreen" component={AnnouncementDetailScreen} />
      <Stack.Screen name="ManageAnnouncementsScreen" component={ManageAnnouncementsScreen} />
      <Stack.Screen name="AdminVerificationAnnonceScreen" component={AdminVerificationAnnonceScreen} />
      <Stack.Screen name="AdminVerificationAnnonceDetailScreen" component={AdminVerificationAnnonceDetailScreen} />
      <Stack.Screen name="ManageUsersScreen" component={ManageUsersScreen} />
      <Stack.Screen name="ManagePaymentsScreen" component={ManagePaymentsScreen} />
      <Stack.Screen name="PaymentDetailScreen" component={PaymentDetailScreen} />
      <Stack.Screen name="CentreScreenDetailleUser" component={CentreScreenDetailleUser} />
      <Stack.Screen name="EditContentScreen" component={EditContentScreen} />
      <Stack.Screen name="EditDocumentScreen" component={EditDocumentScreen} />
      <Stack.Screen name="NotificationsScreen" component={NotificationsScreen} />
      <Stack.Screen name="PaymentScreen" component={PaymentScreen} />
      <Stack.Screen name="HistoriqueDetailScreen" component={HistoriqueDetailScreen} />
      <Stack.Screen name="PDFViewer" component={PDFViewer} />
      <Stack.Screen name="UserDetailScreen" component={UserDetailScreen} />
      <Stack.Screen name="SupportScreen" component={SupportScreen} />
      <Stack.Screen name="AnnouncementPaymentScreen" component={AnnouncementPaymentScreen} />
      <Stack.Screen name="RenewAnnouncementScreen" component={RenewAnnouncementScreen} />
      <Stack.Screen name="AddAdmin" component={AddAdmin} />
      <Stack.Screen name="ForgotPasswordScreen" component={ForgotPasswordScreen} />
      <Stack.Screen name="ChatMayaScreen" component={ChatMayaScreen} />
      <Stack.Screen name="AnalyticsScreen" component={AnalyticsScreen} />
    </Stack.Navigator>
  );
}

export default function App() {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    async function loadFonts() {
      await Font.loadAsync({
        ...MaterialCommunityIcons.font,
      });
      setFontsLoaded(true);
    }
    loadFonts();
  }, []);

  if (!fontsLoaded) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#165ca2" />
      </View>
    );
  }

  return (
    <AuthProvider>
      <ThemeProvider>
        <View style={styles.container}>
          <NavigationContainer>
            <Navigation />
          </NavigationContainer>
        </View>
      </ThemeProvider>
    </AuthProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
